import { render, staticRenderFns } from "./VideoEducation.vue?vue&type=template&id=1d6a23b2&"
import script from "./VideoEducation.vue?vue&type=script&lang=js&"
export * from "./VideoEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports